<template>
  <v-dialog v-model="visible" width="600" persistent scrollable>
    <v-form v-if="visible" ref="form">
      <v-card>
        <dialog-header :title="$t('plannedService.documentSelectDialog.title')" :close="close"/>
        <v-card-text class="pt-5">
          <div class="d-flex flex-column justify-center align-center">
            <camera class="mb-5 mt-5"
                    @photo="photoTaken"
                    ref="camera"/>
            <img v-if="imagePreviewSrc"
                 class="ma-2"
                 style="
                max-width: 300px;
                max-height: 300px;
                width: 100%;
                height: auto;
              "
                 v-bind:src="imagePreviewSrc"
                 alt="preview"/>
          </div>
          <entity-dialog-input-row :label="$t('plannedService.documentSelectDialog.file')" :required="true">
            <div class="d-flex flex-row">
              <v-file-input class="flex-grow-1 mr-5"
                            v-model="selectedFile"
                            outlined
                            dense
                            hide-details="auto"
                            style="max-width: 18em"
                            prepend-icon=""
                            prepend-inner-icon="$file"
                            :rules="[buildRequiredValidator(), buildMaxFileSizeValidator(30)]"/>
              <v-btn @click="takePhoto" small>
                <v-icon>mdi-camera</v-icon>
              </v-btn>
            </div>
          </entity-dialog-input-row>

          <entity-dialog-input-row :label="$t('plannedService.documentSelectDialog.name')" :required="true">
            <v-text-field v-model="name"
                          outlined
                          dense
                          hide-details="auto"
                          style="max-width: 20em"
                          :rules="[buildRequiredValidator(), buildMaxLengthValidator(255)]"/>
          </entity-dialog-input-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="close">
            {{ $t('actions.cancel') }}
          </v-btn>

          <v-btn class="ml-10"
                 type="button"
                 tile
                 color="primary"
                 dark
                 :loading="uploading"
                 @click="save">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import DocumentsService from '@/services/DocumentsService';
import Camera from '@/components/inputs/Camera';
import {
  buildRequiredValidator,
  buildMaxLengthValidator,
  buildMaxFileSizeValidator,
} from '@/utils/ValidatorBuilders';
import DialogHeader from '@/components/layouts/DialogHeader';

export default {
  name: 'DocumentSelectDialog',
  components: { DialogHeader, Camera, EntityDialogInputRow },
  data: () => ({
    visible: false,
    name: null,
    selectedFile: null,
    uploading: false,
  }),
  computed: {
    imagePreviewSrc() {
      if (this.selectedFile && this.selectedFile.type.startsWith('image')) {
        return URL.createObjectURL(this.selectedFile);
      }
      return null;
    },
  },
  methods: {
    buildRequiredValidator,
    buildMaxLengthValidator,
    buildMaxFileSizeValidator,

    show() {
      this.uploading = false;
      this.name = '';
      this.selectedFile = null;
      this.visible = true;
    },

    takePhoto() {
      this.selectedFile = null;
      this.$refs.camera.openCamera();
    },

    photoTaken(file) {
      this.selectedFile = file;
    },

    save() {
      if (this.uploading) {
        return;
      }

      if (!this.$refs.form.validate()) {
        return;
      }

      this.uploading = true;
      DocumentsService.upload(this.name, this.selectedFile)
          .then((result) => {
            let document = result.data;
            document.data = null;
            this.$emit('uploaded', document);
            this.close();
          })
          .catch((result) => {
            console.log(JSON.stringify(result));
          })
          .finally(() => {
            this.uploading = false;
          });
    },

    close() {
      this.visible = false;
      this.document = null;
      this.selectedFile = null;
    },
  },
};
</script>

<style scoped>
.headline {
  display: flex;
  justify-content: space-between;
  background-color: var(--v-primary-base);
  color: #fff;
  font-weight: 400;
}
</style>
